// casesApi.ts
import { baseApi } from "@shared/api/baseApi"; // Import shared baseApi

export interface CaseItem {
  id: string;
  name: string;
  imageLink: string;
  price: number;
  numberOfGames: number;
  createdAt?: string;
}

export interface GetCasesResponse {
  cases: CaseItem[];
}

export interface CaseProduct {
  id: string;
  name: string;
  imageLink: string;
  price: number;
  caseId: string;
}

export interface GetCaseProductsResponse {
  caseProducts: CaseProduct[];
}

export interface CasesQueryParams {
  limit?: number;
  page?: number;
  sortKey?: string;
  sortDir?: string;
}

export interface UserCaseProgress {
  caseId: string;
  remainingGames: number;
  points: number;
  startedAt: string;
}

export interface BuyCaseResponse {
  success: boolean;
  status: number;
  message: string;
}

// Inject endpoints into the shared baseApi
export const casesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCases: builder.query<GetCasesResponse, CasesQueryParams>({
      query: (params) => ({
        url: "cases",
        params,
      }),
    }),
    getCaseProducts: builder.query<GetCaseProductsResponse, string>({
      query: (caseId) => ({
        url: "case_products",
        params: { caseId },
      }),
    }),
    getUserCaseProgress: builder.query<{ userCaseProgress: UserCaseProgress[] }, void>({
      query: () => `cases/user_progress`,
    }),
    buyCase: builder.mutation<BuyCaseResponse, string>({
      query: (caseId) => ({
        url: "cases/buy",
        method: "POST",
        params: { caseId },
      }),
    }),
  }),
});

export const { 
  useGetCasesQuery, 
  useGetCaseProductsQuery, 
  useGetUserCaseProgressQuery,
  useBuyCaseMutation 
} = casesApi;
